// Shared helpers for rendering/handling POST /api/ai/chat responses.
// Used by ServiceNowTicketModal.tsx (handoff notes) and AiSummaryModal.tsx
// (channel/email summaries) — both hit the same real endpoint, and the
// model inconsistently returns **bold** inline markers and/or `## Heading`
// lines depending on the prompt, neither of which should show up as literal
// markdown syntax in the UI.

function renderInline(text: string, keyPrefix: string) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith('**') && part.endsWith('**')
      ? <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>
      : <span key={`${keyPrefix}-${i}`}>{part}</span>
  );
}

export function renderAiText(text: string) {
  return text.split('\n').map((line, li) => {
    const heading = line.match(/^#{1,4}\s+(.*)$/);
    if (!line.trim()) return <div key={li}>&nbsp;</div>;
    if (heading) {
      return (
        <div key={li} style={{ fontWeight: 800, marginTop: li > 0 ? 10 : 0 }}>
          {renderInline(heading[1], String(li))}
        </div>
      );
    }
    return <div key={li}>{renderInline(line, String(li))}</div>;
  });
}

export function aiErrorMessage(status: number, body: any): string {
  if (body?.error === 'ai_unconfigured' || status === 503) return "AI isn't configured in this environment.";
  if (status === 429) return 'Rate limited — try again in a moment.';
  if (body?.error === 'ai_upstream_error' || status === 502) return 'AI request failed upstream — try again.';
  return 'AI generation failed — try again.';
}
